// TABS CASAS ETAPA 01
const tabsCasasEtapa01 = () => {
  // Tabs Button -> Tipo Casa
  const tabCasaA = document.querySelector('#containerCasasEtapa01 #etapa-01-casa-a-tab');
  const tabCasaB = document.querySelector('#containerCasasEtapa01 #etapa-01-casa-b-tab');
  const tabCasaC = document.querySelector('#containerCasasEtapa01 #etapa-01-casa-c-tab');
  const contentCasaA = document.querySelector('#containerCasasEtapa01 .content-spec.casa-a');
  const contentCasaB = document.querySelector('#containerCasasEtapa01 .content-spec.casa-b');
  const contentCasaC = document.querySelector('#containerCasasEtapa01 .content-spec.casa-c');

  tabCasaA.addEventListener('click', () => {
    contentCasaB.classList.add('d-none');
    contentCasaC.classList.add('d-none');
    contentCasaA.classList.remove('d-none');
  });
  tabCasaB.addEventListener('click', () => {
    contentCasaA.classList.add('d-none');
    contentCasaC.classList.add('d-none');
    contentCasaB.classList.remove('d-none');
  });
  tabCasaC.addEventListener('click', () => {
    contentCasaA.classList.add('d-none');
    contentCasaB.classList.add('d-none');
    contentCasaC.classList.remove('d-none');
  });

  /**************************** */

  // Casa A Piso 1
  const indicadoresA01 = document.querySelectorAll('#tabsCasasEtapa01 .piso-a-01 .indicador');
  const interaccionesCasaA01 = document.querySelectorAll('#tabsCasasEtapa01 .interacciones-a-01 .interaccion');
  const contentCasaA01 = document.querySelectorAll('#containerCasasEtapa01 .content-spec.casa-a .piso-01 .content-interaction');

  // Casa A Piso 2
  const indicadoresA02 = document.querySelectorAll('#tabsCasasEtapa01 .piso-a-02 .indicador');
  const interaccionesCasaA02 = document.querySelectorAll('#tabsCasasEtapa01 .interacciones-a-02 .interaccion');
  const contentCasaA02 = document.querySelectorAll('#containerCasasEtapa01 .content-spec.casa-a .piso-02 .content-interaction');



  // Casa B Piso 1
  // const indicadoresB01 = document.querySelectorAll('#tabsCasasEtapa01 .piso-b-01 .indicador');
  // const interaccionesCasaB01 = document.querySelectorAll('#tabsCasasEtapa01 .interacciones-b-01 .interaccion');
  // const contentCasaB01 = document.querySelectorAll('#containerCasasEtapa01 .content-spec.casa-b .piso-01 .content-interaction');

  // Casa B Piso 2
  // const indicadoresB02 = document.querySelectorAll('#tabsCasasEtapa01 .piso-b-02 .indicador');
  // const interaccionesCasaB02 = document.querySelectorAll('#tabsCasasEtapa01 .interacciones-b-02 .interaccion');
  // const contentCasaB02 = document.querySelectorAll('#containerCasasEtapa01 .content-spec.casa-b .piso-02 .content-interaction');

  // Tabs buttons by Piso
  const tabCasaAPiso01 = document.querySelector('#tipo-casa-a-01');
  const tabCasaAPiso02 = document.querySelector('#tipo-casa-a-02');

  // const tabCasaBPiso01 = document.querySelector('#tipo-casa-b-01');
  // const tabCasaBPiso02 = document.querySelector('#tipo-casa-b-02');
  
  // CASA A PISO 01
  indicadoresA01.forEach( (indicador) => {
    // For Desktop
    if(window.innerWidth > 767){
      indicador.addEventListener('mouseover', (event) => {
        const mouseEvent = event.target.dataset.mouse;
        
        interaccionesCasaA01.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaA01[mouseEvent].classList.remove('d-none');

        contentCasaA01.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaA01[mouseEvent].classList.remove('d-none');
      });
      indicador.addEventListener('mouseleave', () => {
        interaccionesCasaA01.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaA01[0].classList.remove('d-none');

        contentCasaA01.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaA01[0].classList.remove('d-none');
      });
    }


    // For Mobile
    else{
      indicador.addEventListener('click', (event) => {
        const mouseEvent = event.target.dataset.mouse;
        
        interaccionesCasaA01.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaA01[mouseEvent].classList.remove('d-none');

        contentCasaA01.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaA01[mouseEvent].classList.remove('d-none');
      });
      indicador.addEventListener('mouseleave', () => {
        interaccionesCasaA01.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaA01[0].classList.remove('d-none');

        contentCasaA01.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaA01[0].classList.remove('d-none');
      });
    }
  });
  tabCasaAPiso01.addEventListener('click', () => {
    contentCasaA02[0].classList.add('d-none');
    contentCasaA01[0].classList.remove('d-none');
  })

  // CASA A PISO 02
  indicadoresA02.forEach( (indicador) => {
    // For Desktop
    if(window.innerWidth > 767){
      indicador.addEventListener('mouseover', (event) => {
        const mouseEvent = event.target.dataset.mouse;
        
        interaccionesCasaA02.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaA02[mouseEvent].classList.remove('d-none');

        contentCasaA02.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaA02[mouseEvent].classList.remove('d-none');
      });
      indicador.addEventListener('mouseleave', () => {
        interaccionesCasaA02.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaA02[0].classList.remove('d-none');

        contentCasaA02.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaA02[0].classList.remove('d-none');
      });
    }


    // For Mobile
    else{
      indicador.addEventListener('click', (event) => {
        const mouseEvent = event.target.dataset.mouse;
        
        interaccionesCasaA02.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaA02[mouseEvent].classList.remove('d-none');

        contentCasaA02.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaA02[mouseEvent].classList.remove('d-none');
      });
      indicador.addEventListener('mouseleave', () => {
        interaccionesCasaA02.forEach((interaccion) => {
          interaccion.classList.add('d-none');
        });
        interaccionesCasaA02[0].classList.remove('d-none');

        contentCasaA02.forEach((content) => {
          content.classList.add('d-none');
        });
        contentCasaA02[0].classList.remove('d-none');
      });
    }
  });
  tabCasaAPiso02.addEventListener('click', () => {
    contentCasaA01[0].classList.add('d-none');
    contentCasaA02[0].classList.remove('d-none');
  })


  // CASA B PISO 01
  // indicadoresB01.forEach( (indicador) => {
  //   // For Desktop
  //   if(window.innerWidth > 767){
  //     indicador.addEventListener('mouseover', (event) => {
  //       const mouseEvent = event.target.dataset.mouse;
        
  //       interaccionesCasaB01.forEach((interaccion) => {
  //         interaccion.classList.add('d-none');
  //       });
  //       interaccionesCasaB01[mouseEvent].classList.remove('d-none');

  //       contentCasaB01.forEach((content) => {
  //         content.classList.add('d-none');
  //       });
  //       contentCasaB01[mouseEvent].classList.remove('d-none');
  //     });
  //     indicador.addEventListener('mouseleave', () => {
  //       interaccionesCasaB01.forEach((interaccion) => {
  //         interaccion.classList.add('d-none');
  //       });
  //       interaccionesCasaB01[0].classList.remove('d-none');

  //       contentCasaB01.forEach((content) => {
  //         content.classList.add('d-none');
  //       });
  //       contentCasaB01[0].classList.remove('d-none');
  //     });
  //   }


  //   // For Mobile
  //   else{
  //     indicador.addEventListener('click', (event) => {
  //       const mouseEvent = event.target.dataset.mouse;
        
  //       interaccionesCasaB01.forEach((interaccion) => {
  //         interaccion.classList.add('d-none');
  //       });
  //       interaccionesCasaB01[mouseEvent].classList.remove('d-none');

  //       contentCasaB01.forEach((content) => {
  //         content.classList.add('d-none');
  //       });
  //       contentCasaB01[mouseEvent].classList.remove('d-none');
  //     });
  //     indicador.addEventListener('mouseleave', () => {
  //       interaccionesCasaB01.forEach((interaccion) => {
  //         interaccion.classList.add('d-none');
  //       });
  //       interaccionesCasaB01[0].classList.remove('d-none');

  //       contentCasaB01.forEach((content) => {
  //         content.classList.add('d-none');
  //       });
  //       contentCasaB01[0].classList.remove('d-none');
  //     });
  //   }
  // });
  // tabCasaBPiso01.addEventListener('click', () => {
  //   contentCasaB02[0].classList.add('d-none');
  //   contentCasaB01[0].classList.remove('d-none');
  // })

  // // CASA B PISO 02
  // indicadoresB02.forEach( (indicador) => {
  //   // For Desktop
  //   if(window.innerWidth > 767){
  //     indicador.addEventListener('mouseover', (event) => {
  //       const mouseEvent = event.target.dataset.mouse;
        
  //       interaccionesCasaB02.forEach((interaccion) => {
  //         interaccion.classList.add('d-none');
  //       });
  //       interaccionesCasaB02[mouseEvent].classList.remove('d-none');

  //       contentCasaB02.forEach((content) => {
  //         content.classList.add('d-none');
  //       });
  //       contentCasaB02[mouseEvent].classList.remove('d-none');
  //     });
  //     indicador.addEventListener('mouseleave', () => {
  //       interaccionesCasaB02.forEach((interaccion) => {
  //         interaccion.classList.add('d-none');
  //       });
  //       interaccionesCasaB02[0].classList.remove('d-none');

  //       contentCasaB02.forEach((content) => {
  //         content.classList.add('d-none');
  //       });
  //       contentCasaB02[0].classList.remove('d-none');
  //     });
  //   }


  //   // For Mobile
  //   else{
  //     indicador.addEventListener('click', (event) => {
  //       const mouseEvent = event.target.dataset.mouse;
        
  //       interaccionesCasaB02.forEach((interaccion) => {
  //         interaccion.classList.add('d-none');
  //       });
  //       interaccionesCasaB02[mouseEvent].classList.remove('d-none');

  //       contentCasaB02.forEach((content) => {
  //         content.classList.add('d-none');
  //       });
  //       contentCasaB02[mouseEvent].classList.remove('d-none');
  //     });
  //     indicador.addEventListener('mouseleave', () => {
  //       interaccionesCasaB02.forEach((interaccion) => {
  //         interaccion.classList.add('d-none');
  //       });
  //       interaccionesCasaB02[0].classList.remove('d-none');

  //       contentCasaB02.forEach((content) => {
  //         content.classList.add('d-none');
  //       });
  //       contentCasaB02[0].classList.remove('d-none');
  //     });
  //   }
  // });
  // tabCasaBPiso02.addEventListener('click', () => {
  //   contentCasaB01[0].classList.add('d-none');
  //   contentCasaB02[0].classList.remove('d-none');
  // })


}
tabsCasasEtapa01();

// DOM SCRIPTING VIDEO TABS PROYECTO ETAPA 1

const interaccionesTabsMedia = () => {
  const tabMedia01 = document.querySelector('#etapa-01-galeria-tab');
  const tabMedia02 = document.querySelector('#etapa-01-video-tab');
  const tabMedia03 = document.querySelector('#etapa-01-recorrido-tab');
  
  const videoMedia = document.querySelectorAll('.video-tabs-media');

  tabMedia01.addEventListener('click', () => {
    for (let i = 0; i < videoMedia.length; i++) {
      videoMedia[i].pause();
    }
  });

  tabMedia02.addEventListener('click', () => {
    for (let i = 0; i < videoMedia.length; i++) {
      videoMedia[i].pause();
    }
  });

  tabMedia03.addEventListener('click', () => {
    for (let i = 0; i < videoMedia.length; i++) {
      videoMedia[i].pause();
    }
  });

}

const videoHomeInteraction01 = () => {
  const btnPreviewVideo = document.querySelector('#btn-preview-video');
  const videoHomePath = document.querySelector('#video-interaction-01');

  btnPreviewVideo.addEventListener('click', () => {
    btnPreviewVideo.classList.add('d-none');
    videoHomePath.classList.remove('d-none')

    const childVideoCount = videoHomePath.childElementCount;

    if (childVideoCount < 1) {
      const videoHome = document.createElement('VIDEO');
      const videoHomeSrc = document.createElement('SOURCE');
      const videoHomeSrcWebm = document.createElement('SOURCE');
  
      videoHome.setAttribute('controls', 'controls');
      videoHome.setAttribute('autoplay', 'autoplay');
      videoHome.classList.add('video-tabs-media');
  
      videoHomeSrc.setAttribute('src', './build/video/video_corte1_ADP2.mp4');
      videoHomeSrc.setAttribute('type', 'video/mp4');
      videoHome.appendChild(videoHomeSrc);
  
      videoHomeSrcWebm.setAttribute('src', './build/video/video_corte1_ADP2.webm');
      videoHomeSrc.setAttribute('type', 'video/webm');
      videoHome.appendChild(videoHomeSrcWebm);
      
      videoHomePath.appendChild(videoHome);
    } 
    // else {
    //   console.log('Ya esta cargado el video en el DOM');
    // }

    interaccionesTabsMedia();
  });
} 
videoHomeInteraction01();


// IMGS PATHS ETAPAS
const imgEtapa01 = '<img src="./build/img/landing/medalla-1ra-etapa.svg" alt="medalla-1ra-etapa">';

// INFO CASAS
const casa = {
  // ETAPA 01
  // 'item01': {
  //   'titulo': '<span>Casa 1</span> - 3 habitaciones',
  //   'precio': 'Desde $844 millones',
  //   'imgEtapaTooltip': imgEtapa01
  // },
  // 'item02': {
  //   'titulo': '<span>Casa 2</span> - 3 habitaciones',
  //   'precio': 'Desde $800 millones',
  //   'imgEtapaTooltip': imgEtapa01
  // },
  // 'item04': {
  //   'titulo': '<span>Casa 4</span> - 3 habitaciones',
  //   'precio': 'Desde $716 millones',
  //   'imgEtapaTooltip': imgEtapa01
  // },
  'item06': {
    'titulo': '<span>Casa 6</span> - 3 habitaciones',
    'precio': 'Desde $795 millones',
    'imgEtapaTooltip': imgEtapa01
  },
  'item11': {
    'titulo': '<span>Casa 11</span> - 3 habitaciones',
    'precio': 'Desde $775 millones',
    'imgEtapaTooltip': imgEtapa01
  },
  'item12': {
    'titulo': '<span>Casa 12</span> - 3 habitaciones',
    'precio': 'Desde $775 millones',
    'imgEtapaTooltip': imgEtapa01
  },
  'item13': {
    'titulo': '<span>Casa 13</span> - 3 habitaciones',
    'precio': 'Desde $775 millones',
    'imgEtapaTooltip': imgEtapa01
  },
  // 'item17': {
  //   'titulo': '<span>Casa 17</span> - 3 habitaciones',
  //   'precio': 'Desde $778 millones',
  //   'imgEtapaTooltip': imgEtapa01
  // },
  'item20': {
    'titulo': '<span>Casa 20</span> - 3 habitaciones',
    'precio': 'Desde $778 millones',
    'imgEtapaTooltip': imgEtapa01
  },
  'item21': {
    'titulo': '<span>Casa 21</span> - 3 habitaciones',
    'precio': 'Desde $773 millones',
    'imgEtapaTooltip': imgEtapa01
  },
  'item22': {
    'titulo': '<span>Casa 22</span> - 3 habitaciones',
    'precio': 'Desde $773 millones',
    'imgEtapaTooltip': imgEtapa01
  },
  'item23': {
    'titulo': '<span>Casa 23</span> - 3 habitaciones',
    'precio': 'Desde $773 millones',
    'imgEtapaTooltip': imgEtapa01
  },
  // 'item24': {
  //   'titulo': '<span>Casa 24</span> - 3 habitaciones',
  //   'precio': 'Desde $938 millones',
  //   'imgEtapaTooltip': imgEtapa01
  // },
  // 'item27': {
  //   'titulo': '<span>Casa 27</span> - 4 habitaciones',
  //   'precio': 'Desde $818 millones',
  //   'imgEtapaTooltip': imgEtapa01
  // },
  // 'item29': {
  //   'titulo': '<span>Casa 29</span> - 4 habitaciones',
  //   'precio': 'Desde $827 millones',
  //   'imgEtapaTooltip': imgEtapa01
  // },
  'item31': {
    'titulo': '<span>Casa 31</span> - 3 habitaciones',
    'precio': 'Desde $779 millones',
    'imgEtapaTooltip': imgEtapa01
  },
  'item32': {
    'titulo': '<span>Casa 32</span> - 3 habitaciones',
    'precio': 'Desde $784 millones',
    'imgEtapaTooltip': imgEtapa01
  }
}


// MODAL INTERACCIONES PLANOS MOBILE
const modalPlanoMobile = () => {
  const tooltipDesktop = document.querySelector('.tooltip-modal-mobile');
  const titulo = document.querySelector('.tooltip-modal-mobile #titulo');
  const precio = document.querySelector('.tooltip-modal-mobile #precio');
  // const imgEtapaTooltip = document.querySelector('.tooltip-modal-mobile #img-etapa-tooltip');

  const indicadoresTooltips = document.querySelectorAll('.indicador-mobile');

  indicadoresTooltips.forEach((indicador) => {
    indicador.addEventListener('mouseover', (event) => {
      tooltipDesktop.classList.remove('d-none');

      const targetId = event.target.dataset.casaId;
      const tipoEtapa = event.target.dataset.etapa;

      if (tipoEtapa === "1"){
        tooltipDesktop.classList.add('tooltip-modal-mobile--negro');
      }
      else{
        tooltipDesktop.classList.add('tooltip-modal-mobile--blanco');
      }

      const getInfoCasa = casa[`item${targetId}`];
      // console.log(getInfoCasa);

      titulo.innerHTML = getInfoCasa.titulo;
      precio.innerHTML = getInfoCasa.precio;
      // imgEtapaTooltip.innerHTML = getInfoCasa.imgEtapaTooltip;
    });

    indicador.addEventListener('mouseleave', () => {
      tooltipDesktop.classList.add('d-none');
      tooltipDesktop.classList.remove('tooltip-modal-mobile--negro');
      tooltipDesktop.classList.remove('tooltip-modal-mobile--blanco');
      titulo.innerHTML = '';
      precio.innerHTML = '';
      // imgEtapaTooltip.innerHTML = '';
    });
  });
}
modalPlanoMobile();

// MODAL INTERACCIONES PLANOS DESKTOP
const modalPlanoDesktop = () => {
  const tooltipDesktop = document.querySelector('.tooltip-modal-desktop');
  const titulo = document.querySelector('.tooltip-modal-desktop #titulo');
  const precio = document.querySelector('.tooltip-modal-desktop #precio');
  // const imgEtapaTooltip = document.querySelector('.tooltip-modal-desktop #img-etapa-tooltip');

  const indicadoresTooltips = document.querySelectorAll('.indicador-desktop');

  indicadoresTooltips.forEach((indicador) => {
    indicador.addEventListener('mouseover', (event) => {
      tooltipDesktop.classList.remove('d-none');

      const targetId = event.target.dataset.casaId;
      const tipoEtapa = event.target.dataset.etapa;

      if (tipoEtapa === "1"){
        tooltipDesktop.classList.add('tooltip-modal-desktop--negro');
      }
      else{
        tooltipDesktop.classList.add('tooltip-modal-desktop--blanco');
      }

      const getInfoCasa = casa[`item${targetId}`];
      // console.log(getInfoCasa);

      titulo.innerHTML = getInfoCasa.titulo;
      precio.innerHTML = getInfoCasa.precio;
      // imgEtapaTooltip.innerHTML = getInfoCasa.imgEtapaTooltip;
    });

    indicador.addEventListener('mouseleave', () => {
      tooltipDesktop.classList.add('d-none');
      tooltipDesktop.classList.remove('tooltip-modal-desktop--negro');
      tooltipDesktop.classList.remove('tooltip-modal-desktop--blanco');
      titulo.innerHTML = '';
      precio.innerHTML = '';
      // imgEtapaTooltip.innerHTML = '';
    });
  });
}
modalPlanoDesktop();
